'use strict'

/* global cf */

/** @module common
 * @requires module:slider/slider
 * @requires module:ajaxForm
 * @requires module:article
 * @requires lodash/throttle
 * */

/** @external lodash/throttle */

/** @const {string} */

import slider from '../components/slider'
import autocomplete from '../components/autocomplete'
import { throttle } from 'lodash'
import helpers from '../utils/helpers'
import adjustScrollWithHash from '../utils/adjustScrollWithHash'
import validation from '../components/validation'
import toggleBlock from '../components/toggleBlock'
import toggleFaq from '../components/toggleFaq'
import toggleCheckbox from '../components/toggleCheckbox'
import displayRegionName from '../components/displayRegionName'
import header from '../components/header'
import tips from '../components/tips'
import campingMap from '../components/campingMap'
import search from '../components/search'
import { getCookie, initVideo } from '../utils/utils'
import { getSrc } from '../utils/responsiveImage'

const CLASS_ACTIV = 'activ'
const CLASS_VISIBLE = 'visible'
const CLASS_SCROLL = 'scroll'
const CLASS_LAZYLOAD = 'js-lazyload'
const CLASS_TOGGLE_BLOCK = 'js-display-block'
const CLASS_REGION_NAME = 'js-region-name'
const CLASS_TIPS = 'js-bons-plans'
const CLASS_EMBED_VIDEO = 'js-embed-video'
const CLASS_TOGGLE_CHECKBOX = 'js-toggle-checkbox'
const CLASS_TOGGLE_FAQ = 'js-toggle-faq'
const CLASS_CLOSE_MODAL = 'bt-close'
const CLASS_LOGIN_LINK = 'js-login-modal'
const CLASS_LOGGED_USER = 'js-logged-user'
const CLASS_SELECT = 'js-select'
const CLASS_NEWSLETTER = 'js-newsletter'
const CLASS_NEWSLETTER_MSG = 'js-newsletter-msg'
const CLASS_FORGET_PASSWORD = 'js-forget-password'
const CLASS_FORGET_PASSWORD_MSG = 'js-forget-password-msg'

const ID_FORGET_MODAL = 'js-forget-modal'
const ID_BACKDROP = 'js-backdrop'
const ID_MAP = 'js-camping-map'
const ID_HISTORY = 'js-user-history'

const CLASS_MINI_SLIDE = 'mini-slide'
const CLASS_CONTENT_SLIDER = 'content-slider'
const CLASS_GALERIE_PHOTOS = 'galerie-photos'

const SELECTOR_SLIDER = 'js-slider'

const SELECTOR_AUTOCOMPLETE = '.autocomplete-layer'
const SELECTOR_ACCORDION = '.head-bloc-filters'
const SELECTOR_MODAL_TOGGLER = '.lk-forgot'
const SELECTOR_DESC_TOGGLER = '.top-rub .bloc-art .more-desc, .top-results .more-desc, .top-results .desc'

const LOCAL_STORAGE = 'cf_history'
const COOKIE_ISLOGGED = 'CF_LOGIN'

const threshold = 800

const body = document.body

export default {
  /* *
   * Initialisation
   *
   * @method init
   */
  init() {
    helpers()
    adjustScrollWithHash.init()
    header.init()
    this.bind()
    Array.prototype.forEach.call(body.getElementsByClassName(SELECTOR_SLIDER), (sliderElt) => {
      let params = {
        mainGallery: sliderElt
      }
      if (sliderElt.classList.contains(CLASS_MINI_SLIDE)) {
        params = Object.assign({}, params, {
          mainPrevArrow: '.prev',
          mainNextArrow: '.next'
        })
      }
      if (sliderElt.classList.contains(CLASS_CONTENT_SLIDER)) {
        params = Object.assign({}, params, {
          zoomGal: sliderElt,
          zoomGalTop: sliderElt,
          sliderThumb: '.nav-gal',
          sliderThumbEltClickable: 'a',
          autoplay: true
        })
      }
      if (sliderElt.classList.contains(CLASS_GALERIE_PHOTOS)) {
        params = Object.assign({}, params, {
          mainPrevArrow: '.top-gal .nav-gal.prev',
          mainNextArrow: '.top-gal .nav-gal.next',
          secondaryGallery: '.bottom-gal-list-wrapper',
          secondaryPrevArrow: '.bottom-gal .nav-gal.prev',
          secondaryNextArrow: '.bottom-gal .nav-gal.next',
          paginationSelector: '.pagin-photos',
          paginationFormat: 'Photo $1/$2',
          contentImage: '.txt-art img',
          zoomGal: '.galerie-photos-zoom',
          zoomGalTop: '.galerie-photos-zoom .top-gal',
          sliderThumb: '.col-gal-list-wrapper',
          sliderThumbPrevArrow: '.col-gal .nav-gal.prev',
          sliderThumbNextArrow: '.col-gal .nav-gal.next',
          synchronizeGal: true,
          swipeContainer: '.top-gal'
        })
      }
      slider.init(params)
      this.initLazyload(sliderElt)
    })
    if (body.querySelector(SELECTOR_AUTOCOMPLETE) !== null) {
      autocomplete.init()
    }
    if (body.querySelector('form.js-validate')) {
      validation.init()
    }
    if (body.getElementsByClassName(CLASS_TOGGLE_CHECKBOX).length) {
      toggleCheckbox.init()
    }
    if (body.getElementsByClassName(CLASS_TOGGLE_FAQ).length) {
      toggleFaq.init()
    }
    if (body.getElementsByClassName(CLASS_TOGGLE_BLOCK).length) {
      toggleBlock.init()
    }
    if (body.getElementsByClassName(CLASS_REGION_NAME).length
        && cf.regionsName && cf.regionsName.length) {
      displayRegionName.init()
    }
    if (body.getElementsByClassName(CLASS_TIPS).length) {
      tips.init()
    }
    if (document.getElementById(ID_MAP)) {
      window.initMap = campingMap.initMap.bind(campingMap)
      campingMap.init()
    }
    search.init()
    this.checkLoginCookie()
    this.initLazyload()
    this.createHistory()
  },

  bind() {
    const forgetPasswordForm = document.getElementsByClassName(CLASS_FORGET_PASSWORD)
    const toggleDesc = document.querySelectorAll(SELECTOR_DESC_TOGGLER)

    body.bindEvent('click', SELECTOR_ACCORDION, this.toggleAccordion)
    document.querySelectorAll(SELECTOR_MODAL_TOGGLER).bindEvent('click', this.openForgetModal)
    document.getElementsByClassName(CLASS_CLOSE_MODAL).bindEvent('click', this.closeModal)
    document.getElementsByClassName(CLASS_EMBED_VIDEO)
            .bindEvent('click', this.clickOnVideo.bind(this))
    document.getElementById(ID_HISTORY).firstElementChild.bindEvent('click', this.toggleHistory)
    document.getElementsByClassName(CLASS_SELECT).bindEvent('click', this.toggleSelect)
    document.getElementsByClassName(CLASS_NEWSLETTER).item(0)
            .bindEvent('submit', this.subscribeToNewsletter.bind(this))

    if (forgetPasswordForm && forgetPasswordForm.length) {
      forgetPasswordForm[0].bindEvent('submit', this.forgetPassword.bind(this))
    }
    if (toggleDesc && toggleDesc.length) {
      toggleDesc.bindEvent('click', e => {
        if (e.target.href) {
          return
        }
        e.preventDefault()
        e.stopPropagation()
        const currentParent = e.currentTarget.closest('.bloc-art')
                              || e.currentTarget.closest('.top-results')
        if (currentParent.classList.contains(CLASS_ACTIV)) {
          currentParent.classList.remove(CLASS_ACTIV)
        } else {
          currentParent.classList.add(CLASS_ACTIV)
        }
      })
    }
  },

  /* *
   * call Lazyload of images and bind to scroll
   *
   * @function initLazyload
   */
  initLazyload() {
    this.lazyload()
    window.addEventListener('scroll', throttle(() => {
      this.lazyload()
    }, 100))
  },

  /* *
   * Lazyload of images
   *
   * @function lazyload
   */
  lazyload() {
    let picturesAll = document.getElementsByClassName(CLASS_LAZYLOAD) || []
    let pictures = Array.from(picturesAll)
    for (let index = 0; index < pictures.length; index++) {
      let isSlider = false
      let picture = pictures[index]
      let imgs = picture.getElementsByTagName('IMG') || []
      let img = imgs[0]
      let elt = picture

      // if image exist
      if (picture.classList.contains(CLASS_LAZYLOAD) && img) {
        // check if is slider
        while (elt && elt.parentElement) {
          elt = elt.parentElement
          if (elt.parentElement.classList.contains(SELECTOR_SLIDER)) {
            isSlider = true
            elt = null
          } else if (elt.tagName === 'MAIN') {
            elt = null
          }
        }

        if (!isSlider) {
          let top = img.offset().top
          let scrollTop = document.body.scrollTop
          let src = null

          if (top > scrollTop - threshold && top < scrollTop + window.innerHeight + threshold) {
            src = getSrc(picture)
            if (src) {
              img.setAttribute('src', src)
            } else {
              img.setAttribute('src', img.getAttribute('data-original'))
            }
            picture.classList.remove(CLASS_LAZYLOAD)
          }
        }
      }
    }
  },

  /**
   * @description Toggle class CLASS_ACTIV
   * @param {object} e MouseEvent
   * @returns {undefined} none
   */
  toggleAccordion(e) {
    let currentClassList = e.customCurrentTarget.classList
    let nextClassList = e.customCurrentTarget.nextElementSibling.classList

    if (currentClassList.contains(CLASS_ACTIV)) {
      currentClassList.remove(CLASS_ACTIV)
      nextClassList.remove(CLASS_ACTIV)
    } else {
      currentClassList.add(CLASS_ACTIV)
      nextClassList.add(CLASS_ACTIV)
    }
  },

  /**
   * @description add class CLASS_ACTIV on forget password modal
   * @param {object} e MouseEvent
   * @returns {undefined} none
   */
  openForgetModal(e) {
    e.preventDefault()
    document.getElementById(ID_FORGET_MODAL).classList.add(CLASS_ACTIV)
    document.getElementById(ID_BACKDROP).classList.add(CLASS_ACTIV)
  },

  closeModal(e) {
    e.preventDefault()
    e.currentTarget.closest('.popup-modal').classList.remove(CLASS_ACTIV)
    document.querySelector('.modal.activ').classList.remove(CLASS_ACTIV)
  },

  /**
   * @description Check if video player should be initialized
   * @param {object} e MouseEvent
   * @returns {undefined} none
   */
  clickOnVideo(e) {
    const current = e.currentTarget
    const figure = current.tagName === 'FIGURE'
      ? current
      : current.getElementsByTagName('figure').item(0)
    if (!current.closest('.bottom-gal-list-wrapper') && !figure.classList.contains(CLASS_ACTIV)) {
      initVideo(figure)
    }
  },

  /**
   * @description Toggle User history
   * @param {object} e MouseEvent
   * @returns {undefined} none
   */
  toggleHistory(e) {
    e.preventDefault()
    const userHistory = document.getElementById(ID_HISTORY)
    if (userHistory.classList.contains(CLASS_ACTIV)) {
      userHistory.classList.remove(CLASS_ACTIV)
    } else {
      userHistory.classList.add(CLASS_ACTIV)
    }
  },

  toggleSelect(e) {
    const list = e.currentTarget.nextElementSibling
    if (list.classList.contains(CLASS_ACTIV)) {
      list.classList.remove(CLASS_ACTIV)
    } else {
      list.classList.add(CLASS_ACTIV)
    }
  },

  /**
   * @description Create and display user history
   * @returns {undefined} none
   */
  createHistory() {
    const userHistory = document.getElementById(ID_HISTORY)
    const userHistoryData = localStorage.getItem(LOCAL_STORAGE)

    if (userHistoryData) {
      userHistory.getElementsByTagName('ul').item(0).innerHTML
        = JSON.parse(userHistoryData).map((item) => {
        return item.html
      }).join('')
      userHistory.classList.add(CLASS_VISIBLE)
    }
  },

  checkLoginCookie() {
    const cookie = getCookie(COOKIE_ISLOGGED)
    if (!cookie) {
      return
    }
    if (cf && cf.path && cf.path.edit) {
      document.getElementsByClassName(CLASS_LOGIN_LINK).item(0).href = cf.path.edit
    }
    document.getElementsByClassName(CLASS_LOGGED_USER).item(0).innerHTML
      = JSON.parse(decodeURIComponent(cookie)).email
  },

  subscribeToNewsletter(e) {
    e.preventDefault()
    const formElt = document.getElementsByClassName(CLASS_NEWSLETTER)[0]
    const messageElts = document.getElementsByClassName(CLASS_NEWSLETTER_MSG)
    let msgStatus = null
    let msg = null
    const email = formElt.querySelector('[type=email').value

    if (email) {
      fetch(
        formElt.getAttribute('action'),
        {
          method: 'post',
          body: new FormData(formElt)
        }
      )
        .then(response => {
          switch (response.status) {
            case 202:
              msgStatus = 'success'
              break
            case 400:
              msgStatus = 'bad_request'
              break
            default:
              msgStatus = 'error'
              break
          }
          return response.text()
        })
        .then(() => {
          msg = window.cf.newsletter[msgStatus]
          if (msgStatus === 'success') {
            // to hide the form
            formElt.classList.add('success')
          }
          if (messageElts.length) {
            if (msgStatus === 'success') {
              messageElts[0].classList.remove('error')
              messageElts[0].classList.add('success')
            } else if (!messageElts[0].classList.contains('error')) {
              messageElts[0].classList.add('error')
            }
            messageElts[0].innerHTML = msg
          } else {
            formElt.innerHTML +=
              `<p class="insc-nl-msg js-newsletter-msg ${ msgStatus === 'success'
                ? 'success' : 'error' }">${ msg }</p>`
          }
        })
    }
  },

  forgetPassword(e) {
    e.preventDefault()
    const formElt = document.getElementsByClassName(CLASS_FORGET_PASSWORD)[0]
    const messageElts = document.getElementsByClassName(CLASS_FORGET_PASSWORD_MSG)
    let msg = null
    const email = formElt.querySelector('[type=email').value

    if (email) {
      fetch(
        formElt.getAttribute('action'),
        {
          method: 'post',
          body: new FormData(formElt)
        }
      )
        .then(response => {
          let retour = {}
          switch (response.status) {
            case 200:
              retour = response.json()
              break
            case 202:
              retour = { status: response.status }
              break
            default:
              retour = { status: response.status }
              break
          }
          return retour
        })
        .then((json) => {
          let code = ''
          // 200 but error codes
          if (json.error_code) {
            switch (json.error_code) {
              case 1012:
              case 1014:
                code = 'login_not_found'
                break
              case 1001:
                code = 'field_missing'
                break
              default:
                code = 'success'
                break
            }
          } else if (json.status === 202) {
            code = 'success'
          } else if (json.status) {
            code = 'server_error'
          }

          msg = window.cf.forgetpassword[code]

          // if there is already a message displayed
          if (messageElts.length) {
            if (code === 'success') {
              messageElts[0].classList.remove('error')
              messageElts[0].classList.add('success')
            } else if (!messageElts[0].classList.contains('error')) {
              messageElts[0].classList.add('error')
            }
            messageElts[0].innerHTML = msg
          } else {
            formElt.innerHTML +=
              `<p class="forget-password-msg ${CLASS_FORGET_PASSWORD_MSG} ${ code === 'success'
                ? 'success' : 'error' }">${ msg }</p>`
          }
          if (code === 'success') {
            // hide the form
            document.getElementsByClassName('form-forget-password')[0].classList.add('success')
          }
        })
    }
  },

  /* *
   * On scroll
   *
   * @method scroll
   */
  scroll() {
    if (window.scrollY) {
      if (!body.classList.contains(CLASS_SCROLL)) {
        body.classList.add(CLASS_SCROLL)
      }
    } else {
      body.classList.remove(CLASS_SCROLL)
    }
  }
}



// WEBPACK FOOTER //
// ./src/apps/Front/private/js/modules/common.js